export default "__VITE_ASSET__CioegCka__"